import { render, staticRenderFns } from "./workers-item-status.vue?vue&type=template&id=1ef3866d&"
import script from "./workers-item-status.vue?vue&type=script&lang=js&"
export * from "./workers-item-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports